import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "driverlist"
})
export class DriverlistPipe implements PipeTransform {
  transform(value: any, searchText: string, args?: any): any {
    if (!value) return;
    let newVal = value.filter(function(userTrip) {
      if(userTrip.length != 0) {
        if (searchText === "") {
          return true;
        } else if (
          userTrip.list.trip_id.toLowerCase().includes(searchText.toLowerCase()) ||
          userTrip.drivername.toLowerCase().includes(searchText.toLowerCase()) ||
          userTrip.list.start_address.city.toLowerCase().includes(searchText.toLowerCase()) ||
          userTrip.list.end_address.city.toLowerCase().includes(searchText.toLowerCase())||
          userTrip.list.start_date.toLowerCase().includes(searchText.toLowerCase())
        ) {
          return true;
        } else {
          true;
        }
      }
      return false;
    });
    // newVal.sort((a: any, b:any) =>{
    //   if(a<b){
    //     return 1;
    //   }
    //   else if(b>a){
    //     return -1;
    //   }
    //   else{
    //     return 0;
    //   }
    // })
    return newVal;
  }
}
